<template>
    <v-card style="border-radius: 1em;" class="pa-2">
        <v-card-title>
            <v-btn icon @click="$emit('fechar')">
                <v-icon>close</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <h2>Contrato Padrão</h2>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text v-if="!loading">
            <v-layout row wrap>
                <v-flex>
                  <h2 style="text-align: center;">Taxas de Faturamento</h2>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_empresa"
                    label="Tem taxa de abastecimento por empresa"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_empresa">
                  <v-text-field
                    v-model="taxa_empresa"
                    v-if="rendering"
                    outline
                    label="Taxa de abastecimento por empresa"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                  <h5>Em cada abastecimento {{taxa_empresa}}% pertence a Apetrus.</h5>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_valor_mensal_fatura"
                    label="Tem mensalidade"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_valor_mensal_fatura">
                  <v-text-field
                    v-model.lazy="valor_fatura_mensal"
                    v-if="rendering"
                    outline
                    label="Mensalidade"
                    v-money="money"
                    prefix="R$"
                    hide-details
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_por_abastecimento"
                    label="Tem taxa por abastecimento"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_por_abastecimento">
                  <v-text-field
                    v-model="taxa_por_recimento"
                    v-if="rendering"
                    outline
                    label="Taxa por abastecimento"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_assinatura"
                    label="Tem taxa por assinatura"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_assinatura">
                  <v-text-field
                    v-model="taxa_assinatura"
                    v-if="rendering"
                    outline
                    label="Taxa por assinatura"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 class="mt-4">
                  <v-spacer></v-spacer>
                  <v-divider></v-divider>
                  <h2 style="text-align: center;" class="mt-4">Taxas da Carteira Digital</h2>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_carteira_clientes"
                    label="Tem taxa de recebimento por clientes"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_carteira_clientes">
                  <v-text-field
                    v-model="taxa_recebimento_cliente"
                    v-if="rendering"
                    outline
                    label="Taxa de recebimento por clientes"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_taxa_carteira_empresa"
                    label="Tem taxa de recebimento por empresa"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_taxa_carteira_empresa">
                  <v-text-field
                    v-model="taxa_recebimento_empresa"
                    v-if="rendering"
                    outline
                    label="Taxa de recebimento por empresa"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-switch
                    v-model="tem_desconto_carteira_digital"
                    label="Tem desconto aplicado a compra com a carteira"
                    color="primary"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 v-if="tem_desconto_carteira_digital">
                  <v-text-field
                    v-model="desconto_carteira_digital"
                    v-if="rendering"
                    outline
                    label="Desconto aplicado a compra com a carteira"
                    hide-details
                    type="number"
                    suffix="%"
                  ></v-text-field>
                </v-flex>
              </v-layout>
        </v-card-text>
        <v-card-text v-else>
            <v-layout justify-center>
                <v-progress-circular
                    indeterminate
                    color="primary"
                ></v-progress-circular>
            </v-layout>
        </v-card-text>
        <v-card-actions>
            <v-btn color="success" class="mb-2" block round @click="alterarContratoPadrao">
                <v-icon class="mr-1">save</v-icon>
                salvar
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>

import { VMoney } from 'v-money'

export default {
    directives: { money: VMoney },
    data: () => ({
        rendering: true,
        tem_taxa_empresa: false,
        tem_valor_mensal_fatura: false,
        tem_taxa_por_abastecimento: false,
        tem_taxa_carteira_clientes: false,
        tem_taxa_carteira_empresa: false,
        tem_taxa_assinatura: false,
        taxa_recebimento_empresa: undefined,
        taxa_recebimento_cliente: undefined,
        tem_desconto_carteira_digital: undefined,
        valor_fatura_mensal: undefined,
        taxa_por_recimento: undefined,
        taxa_empresa: undefined,
        taxa_assinatura: undefined,
        desconto_carteira_digital: undefined,
        money: {
            decimal: ',',
            thousands: '.',
            prefix: '',
            precision: 2,
            masked: false
        }
    }),
    computed: {
        loading () {
            return this.$store.getters.loading
        }
    },
    watch: {
        tem_taxa_por_abastecimento (val) {
            if (!val) {
                this.taxa_por_recimento = undefined
            }
        },
        tem_taxa_empresa (val) {
            if (!val) {
                this.taxa_empresa = undefined
            }
        },
        tem_taxa_carteira_clientes (val) {
            if (!val) {
                this.taxa_recebimento_cliente = undefined
            }
        },
        tem_taxa_carteira_empresa (val) {
            if (!val) {
                this.taxa_recebimento_empresa = undefined
            }
        },
        tem_valor_mensal_fatura (val) {
            if (!val) {
                this.valor_fatura_mensal = undefined
            }
        },
        tem_taxa_assinatura (val) {
            if (!val) {
                this.taxa_assinatura = undefined
            }
        },
        tem_desconto_carteira_digital (val) {
            if (!val) {
              this.desconto_carteira_digital = undefined
            }
        }
    },
    beforeMount () {
        this.pegarContrato()
    },
    methods: {
        pegarContrato () {
            this.$store.dispatch('contratoPosto', { method: 'GET' }).then(contrato => {
                this.taxa_por_recimento = contrato.taxa_por_recimento ? contrato.taxa_por_recimento : undefined
                this.taxa_empresa = contrato.taxa_empresa ? contrato.taxa_empresa : undefined
                this.taxa_recebimento_cliente = contrato.taxa_recebimento_cliente ? contrato.taxa_recebimento_cliente : undefined
                this.taxa_recebimento_empresa = contrato.taxa_recebimento_empresa ? contrato.taxa_recebimento_empresa : undefined
                this.valor_fatura_mensal = contrato.valor_fatura_mensal ? contrato.valor_fatura_mensal : undefined
                this.desconto_carteira_digital = contrato.desconto_carteira_digital
                this.tem_taxa_por_abastecimento = !!this.taxa_por_recimento
                this.tem_taxa_carteira_clientes = !!this.taxa_recebimento_cliente
                this.tem_taxa_carteira_empresa = !!this.taxa_recebimento_empresa
                this.tem_taxa_empresa = !!this.taxa_empresa
                this.tem_valor_mensal_fatura = !!this.valor_fatura_mensal
                this.taxa_assinatura = contrato.taxa_assinatura
                this.tem_taxa_assinatura = !!this.taxa_assinatura
                this.tem_desconto_carteira_digital = !!this.desconto_carteira_digital
            })
        },
        alterarContratoPadrao () {
            this.$store.dispatch('contratoPosto', {
                method: 'POST',
                taxa_por_recimento: this.tem_taxa_por_abastecimento ? this.taxa_por_recimento : null,
                taxa_recebimento_cliente: this.tem_taxa_carteira_clientes ? this.taxa_recebimento_cliente : null,
                taxa_recebimento_empresa: this.tem_taxa_carteira_empresa ? this.taxa_recebimento_empresa : null,
                taxa_empresa: this.tem_taxa_empresa ? this.taxa_empresa : null,
                taxa_assinatura: this.tem_taxa_assinatura ? this.taxa_assinatura : null,
                desconto_carteira_digital: this.tem_desconto_carteira_digital ? this.desconto_carteira_digital : null,
                valor_fatura_mensal: this.tem_valor_mensal_fatura ? this.valor_fatura_mensal.replaceAll('.', '').replace(',', '.') : null
            }).then(() => {
                this.$emit('success', 'Contrato Padrão atualizado com sucesso.')
            })
        }
    }
}
</script>
